<template>
    <div class="news-block">
        <div class="news-type">
            <img :src="logoUrl"/>
        </div>
        <div class="news-line"></div>
        <div class="news-list" >
            <NewsItem25  v-for="item in list" :key="item.contentId"  :content="item"/>
        </div>
    </div>
</template>

<script>
import NewsItem25 from "../components/MobileNewsItem50"

export default {
    components: {NewsItem25},
    props:{
        list: {
            type: Array,
            default: () => [],
        },
        logoUrl:{
            type:String,
            default:""
        }
    }
}
</script>

<style scoped>
.news-block{
    width: 100%;
    margin: 0 auto;
}
.news-type{
    text-align: center;
    margin-top: 32px;
}
.news-type img{
    width: 110px;
}
.news-line{
    margin-top: 16px;
    margin-bottom: 0px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    border-top: 1px dashed #2E3855;
}
.news-list{
    display: flex;
    flex-direction: row;
    align-items: baseline;
    flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/MobileIndexNews.vue